import { render, staticRenderFns } from "./swiper-add-or-update.vue?vue&type=template&id=74264c68"
import script from "./swiper-add-or-update.vue?vue&type=script&lang=js"
export * from "./swiper-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./swiper-add-or-update.vue?vue&type=style&index=0&id=74264c68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports